// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"84":"6bf9d0e800ea87d7cc69","875":"2c821ff43123006ee1e0"}[chunkId] + ".js";
};